import { __ } from '../../../Utils';

import BaseLayout from '../../BaseLayout';

class BaseCatalogLayout extends BaseLayout {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      checkedFilter: [],
      defaultFilter: [],
      doNotLoadFilters: false,
      showFilter: true,
      maxFilterWidth: 140,
      showPager: true,
      showSearch: true,
      buttonsSwitch: [
        {
          label: __('Katalóg'),
          url: './catalog',
          rolesExcluded: [],
        },
        {
          label: __('Výpredaj'),
          url: './sales',
          rolesExcluded: [],
        },
        // {
        //   label: __('Položky'),
        //   url: './products',
        //   rolesExcluded: [],
        // },
        {
          label: __('Kampane'),
          url: './campaigns',
          rolesExcluded: ['b2b_user'],
        },
        // {
        //   label: __('Náterové systémy'),
        //   url: './paint-systems',
        // },
      ],
      actualPage: 1,
      offset: 0,
      limit: 25,
      previousLevel: 0,
      loading: true,
      items: [],
      tableItems: [],
      filters: [],
      notFoundMessage: '',
      defaultSearchText: '',
    };
  }

  render() {
    return super.render();
  }
}

export default BaseCatalogLayout;



// WEBPACK FOOTER //
// ./src/Containers/Buy/BaseList/index.jsx